__turbopack_context__.v({
  "button": "newsletter-form-module-scss-module__j4HbRW__button",
  "check": "newsletter-form-module-scss-module__j4HbRW__check",
  "consent": "newsletter-form-module-scss-module__j4HbRW__consent",
  "hidden": "newsletter-form-module-scss-module__j4HbRW__hidden",
  "input": "newsletter-form-module-scss-module__j4HbRW__input",
  "root": "newsletter-form-module-scss-module__j4HbRW__root",
  "row": "newsletter-form-module-scss-module__j4HbRW__row",
  "status": "newsletter-form-module-scss-module__j4HbRW__status",
  "title": "newsletter-form-module-scss-module__j4HbRW__title",
});
